import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { ProjectValuationHostComponent } from './project-valuation-host/project-valuation-host.component';

/**
 * Project Valuation module routing
 */
@NgModule({
  imports: [RouterModule.forChild([
    {
      path: '',
      component: ProjectValuationHostComponent
    }
  ])],
  exports: [RouterModule],
})
export class ProjectValuationRoutingModule { }
